import { storeService } from '@/domain/Store'
import { WithAverageRating } from '@/domain/Store/repositories/store'
import { Store } from '@medusajs/medusa'

const CACHE_KEY = 'store_'

export function getStoreFromHeaders(headers) {
    const storeHeader = headers['x-store']
    if (!storeHeader) return ''

    return Array.isArray(storeHeader) ? storeHeader[0] : storeHeader
}

export function getStore() {
    const store = process.env.NEXT_PUBLIC_STORE
    return store || null
}

export  function getStoreName() {
    const store =  getCachedStoreSync()
    return store?.name;
}

export  function isWithCategorie() {
    const HIDEMENU = process.env.NEXT_PUBLIC_HIDE_MENU
    return HIDEMENU != "YES"
}


export async function getCachedStore(): Promise<(Store & WithAverageRating) | null> {

    const storeId = getStore();

    if ( !storeId)
        return null;

    
    try {
        const cached = sessionStorage.getItem(`${CACHE_KEY}${storeId}`)
        if (cached) {
            return JSON.parse(cached)
        }
    } catch {
        // sessionStorage indisponible (SSR)
    }

    try {
        const res = await storeService.getStoreById(storeId)
        if (res) {
            sessionStorage.setItem(`${CACHE_KEY}${storeId}`, JSON.stringify(res))
        }
        return res
    } catch {
        return null
    }
}

export function getCachedStoreSync(): (Store & WithAverageRating) | null {
    try {
        const storeId = getStore()
        if (!storeId) return null
        
        const cached = sessionStorage.getItem(`${CACHE_KEY}${storeId}`)
        if (cached) return JSON.parse(cached)
    } catch {
        // SSR
    }
    return null
}



export async function fetchWithStore(input: RequestInfo, init?: RequestInit) {
    const headers = new Headers(init?.headers || {})

    // Ajoute X-STORE si défini
    const store = process.env.NEXT_PUBLIC_STORE
    if (store) {
        headers.set('X-STORE', store)
    }

    return fetchWithStore(input, { ...init, headers })
}
